import { OWNER_ROLES } from './navigation';

// User status enum
export enum OWNER_STATUS {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  PENDING = 'pending',
  SUSPENDED = 'suspended',
}

// Owner/User interface based on frontend needs
export interface Owner {
  _id: string;
  email: string;
  name?: string;
  role: OWNER_ROLES;
  status: OWNER_STATUS;
  created_at?: string;
  updated_at?: string;
  person_id?: string; // For backward compatibility
  profile?: {
    firstName?: string;
    lastName?: string;
    avatar?: string;
  };
}

// Agent interface for frontend
export interface Agent {
  _id: string;
  name: string;
  business_id: string;
  owner_id: string;
  evergreen_mode: boolean;
  manual_mode: boolean;
  created_at: string;
  configuration?: {
    system_prompt?: {
      en?: string;
      es?: string;
    };
  };
  agentSubscription?: {
    currentMessageNumber: number;
    subscriptionPlan: number;
    cutoffDate: string;
    startDate: string;
    isProduction: boolean;
  };
}

// Business interface for frontend
export interface Business {
  _id: string;
  name: string;
  owner_id: string;
  created_at: string;
}
